import {
    ADD_TABBY_FAILED, ADD_TABBY_LOADING, ADD_TABBY_REMOVE, ADD_TABBY_SUCCESS
} from "../types";

const initialState = {
    loading: false,
    error: null,
    status: null,
    Tabby: null,
    request: null,
};

export const TabbyReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; status: any; error: any, request: any }
) => {
    switch (action.type) {
        case ADD_TABBY_LOADING:
            return {
                ...state,
                loading: true,
            };
        case ADD_TABBY_SUCCESS:
            return {
                ...state,
                loading: false,
                tabby: action.payload,
                status: action.status,
                error: null,
                request: action.request
            };
        case ADD_TABBY_FAILED:
            return {
                ...state,
                loading: false,
                status: action.status,
                error: action.error,
                request: action.request

            };
        case ADD_TABBY_REMOVE:
            return initialState

        default:
            return state;
    }
};




